import { TRIAL_DAYS } from "../constants/trial";

export function formatSubscriptionRub(n) {
  return new Intl.NumberFormat("ru-RU").format(Number(n) || 0);
}

export function resolveSubscriptionPresentation(billing, clubName = "клуб") {
  if (!billing) {
    return { variant: "loading", clubName };
  }

  const trialDays = billing.trial_days || TRIAL_DAYS;
  const daysLeft = billing.days_left;
  const isDemoExpired = Boolean(billing.is_demo_expired);
  const isTrial = Boolean(billing.is_trial && billing.is_paid && !isDemoExpired);
  const isPaid = Boolean(billing.is_paid);
  const isExpiring = Boolean(billing.is_expiring_soon && !isTrial);
  const readOnly = !isPaid;

  const progress =
    isTrial && daysLeft != null && daysLeft >= 0
      ? Math.max(0, Math.min(100, Math.round((daysLeft / trialDays) * 100)))
      : isPaid && daysLeft != null && daysLeft <= 30
        ? Math.max(0, Math.min(100, Math.round((daysLeft / 30) * 100)))
        : null;

  if (isDemoExpired || (!isPaid && billing.status === "trial")) {
    return {
      variant: "expired",
      clubName,
      readOnly: true,
      badge: "Демо истекло",
      title: "Демо закончилось",
      subtitle: "Режим просмотра",
      meta: "Изменения недоступны · оплатите тариф, чтобы продолжить",
      progress: 0,
      progressLabel: null,
      ctaLabel: "Оплатить",
      ctaHint: null,
    };
  }

  if (isTrial) {
    const cleanLabel = String(billing.plan_label || "")
      .replace(/\s*·\s*демо$/i, "")
      .trim();
    const lastDay = daysLeft === 0;
    return {
      variant: "trial",
      clubName,
      readOnly: false,
      badge: "Демо",
      title: cleanLabel || "Максимальный",
      subtitle: "Полный доступ ко всем функциям",
      meta: lastDay
        ? `Последний день демо из ${trialDays}`
        : daysLeft != null
          ? `Осталось ${daysLeft} из ${trialDays} дн.`
          : `Пробный период ${trialDays} дней`,
      progress,
      progressLabel: lastDay
        ? "сегодня"
        : daysLeft != null
          ? `${daysLeft} дн.`
          : null,
      ctaLabel: "Выбрать тариф",
      ctaHint: null,
    };
  }

  if (!isPaid) {
    return {
      variant: "unpaid",
      clubName,
      readOnly: true,
      badge: "Не оплачен",
      title: "Тариф не оплачен",
      subtitle: "Режим просмотра",
      meta: "Изменения недоступны · клиентский портал работает",
      progress: 0,
      progressLabel: null,
      ctaLabel: "Оплатить",
      ctaHint: null,
    };
  }

  if (isExpiring) {
    return {
      variant: "expiring",
      clubName,
      readOnly: false,
      badge: billing.status_label || "Активна",
      title: billing.plan_label || "Подписка",
      subtitle: `Клуб «${clubName}»`,
      meta:
        daysLeft != null
          ? `Оплачено до ${billing.paid_until || "—"} · осталось ${daysLeft} дн.`
          : "Скоро потребуется продление",
      progress,
      progressLabel: daysLeft != null ? `${daysLeft} дн.` : null,
      ctaLabel: "Продлить",
      ctaHint: null,
    };
  }

  return {
    variant: "active",
    clubName,
    readOnly: false,
    badge: billing.status_label || "Активна",
    title: billing.plan_label || "Подписка",
    subtitle: `Клуб «${clubName}»`,
    meta: billing.paid_until
      ? `Оплачено до ${billing.paid_until}${daysLeft != null ? ` · ${daysLeft} дн.` : ""}`
      : "Подписка активна",
    progress: null,
    progressLabel: null,
    ctaLabel: "Сменить тариф",
    ctaHint: null,
  };
}

export function subscriptionAccessLines(access, billing) {
  if (billing?.is_demo_expired || (!billing?.is_paid && !billing?.is_trial)) {
    return [
      { text: "Просмотр журнала, клиентов и расписания", ok: true },
      { text: "Добавление и редактирование", ok: false },
      { text: "Ответы «Приду» у тренера", ok: false },
      { text: "Клиентский портал", ok: true },
    ];
  }
  if (billing?.is_trial && billing?.is_paid) {
    return [
      { text: "Полный функционал «Максимального»", ok: true },
      { text: "Соцсеть, лента, опросы, персонализация", ok: true },
    ];
  }
  if (!billing?.is_paid) {
    return [
      { text: "Просмотр журнала, клиентов и расписания", ok: true },
      { text: "Добавление и редактирование", ok: false },
      { text: "Ответы «Приду» у тренера", ok: false },
      { text: "Клиентский портал", ok: true },
    ];
  }
  const lines = [];
  if (access?.limits?.trainers) {
    lines.push({ text: `До ${access.limits.trainers} тренеров`, ok: true });
  }
  if (access?.limits?.clients) {
    lines.push({ text: `До ${access.limits.clients} участников`, ok: true });
  }
  if (access?.memberSocial) lines.push({ text: "Соцсеть участников", ok: true });
  if (access?.clubLife) lines.push({ text: "Лента клуба", ok: true });
  if (access?.showPortalBrandingTab) {
    lines.push({ text: "Персонализация портала", ok: true });
  }
  if (access?.polls) lines.push({ text: "Опросы и «Приду»", ok: true });
  return lines;
}
